import { JSONSchema6 } from "json-schema";

const updateCheckoutSessionSchema: JSONSchema6 = {
    title: "UpdateCheckoutSession",
    description: "Update the Checkout Session with transaction details. You can keep updating the Checkout Session until the buyer is redirected to amazonPayRedirectUrl. Once all mandatory parameters have been set, the Checkout Session object will respond with an unique amazonPayRedirectUrl that you will use to redirect the buyer to complete checkout.  Set chargeAmount to the value that should be processed using the paymentIntent during checkout. If you need to split the order to capture additional payment after checkout is complete, use the optional totalOrderAmount parameter to set the full order amount.",
    properties: {
        "pathParam": {
            title: "checkoutSessionId",
            type: "string",
        },
        "header": {
            type: "object",
            properties: {
                "x-amz-pay-simulation-code": {
                    title: "x-amz-pay-simulation-code",
                    type: "string"
                }
            },
        },
        "payload": {
            type: "object",
            properties: {
                "chargePermissionType": {
                    type: "string",
                    enum: ["OneTime", "Recurring", "PaymentMethodOnFile"],
                    default: "OneTime"
                },
                "webCheckoutDetails": {
                    type: "object",
                    properties: {
                        checkoutReviewReturnUrl: {
                            type: "string",
                            maxLength: 512
                        },
                        checkoutResultReturnUrl: {
                            type: "string",
                            maxLength: 512
                        }
                    }
                },
                "recurringMetadata": {
                    type: "object",
                    properties: {
                      "frequency": {
                        type: "object",
                        properties: {
                          "unit": {
                            type: "string",
                            enum: ["", "Year", "Month", "Week", "Day", "Variable"] }
                          ,
                          "value": {
                            type: "string"
                          }
                        }
                      },
                      "amount": {
                        type: "object",
                        description: "Transaction amount",
                        properties: {
                          "amount": {
                            type: "string"
                          },
                          "currencyCode": {
                            type: "string",
                            enum: ["", "AUD", "GBP", "DKK", "EUR", "HKD", "JPY", "NZD", "NOK", "ZAR", "SEK", "CHF", "USD"] }
                          }
                        }
                    }
                },
                "paymentDetails": {
                    type: "object",
                    properties: {
                        paymentIntent: {
                          type: "string",
                          enum: ["Confirm", "Authorize", "AuthorizeWithCapture"]
                        },
                        "canHandlePendingAuthorization": {
                          type: "boolean"
                        },
                        "chargeAmount": {
                          type: "object",
                          description: "Transaction amount",
                          properties: {
                            "amount": {
                              type: "string"
                            },
                            "currencyCode": {
                              type: "string",
                              enum: ["", "AUD", "GBP", "DKK", "EUR", "HKD", "JPY", "NZD", "NOK", "ZAR", "SEK", "CHF", "USD"]
                            }
                          }
                        },
                        "totalOrderAmount": {
                          type: "object",
                          description: "Transaction amount",
                          properties: {
                            "amount": {
                              type: "string"
                              },
                            "currencyCode": {
                              type: "string",
                              enum: ["", "AUD", "GBP", "DKK", "EUR", "HKD", "JPY", "NZD", "NOK", "ZAR", "SEK", "CHF", "USD"]
                            }
                          }
                        },
                        "presentmentCurrency": {
                          type: "string",
                          enum: ["", "AUD", "GBP", "DKK", "EUR", "HKD", "JPY", "NZD", "NOK", "ZAR", "SEK", "CHF", "USD"]
                        },
                        "softDescriptor": {
                          type: "string",
                          maxLength: 16
                        },
                        "allowOvercharge": {
                          title: "Allow Overcharge",
                          type: "boolean"
                        },
                        "extendExpiration": {
                          type: "boolean"
                        }
                    }
                },
                "merchantMetadata": {
                    type: "object",
                    properties: {
                        "merchantReferenceId": {
                          type: "string",
                          maxLength: 256
                        },
                        "merchantStoreName": {
                          type: "string",
                          maxLength: 50
                        },
                        "noteToBuyer": {
                          type: "string",
                          maxLength: 255
                        },
                        customInformation: {
                          type: "string",
                          maxLength: 4096
                        }
                    }
                },
                "platformId": {
                    type: "string"
                },
                "providerMetadata": {
                    type: "string"
                }
            }
        }
    },
    required: ["pathParam"]
}

export default updateCheckoutSessionSchema
